import { lazyLoad } from 'utils/loadable';

export const ManagerPage = lazyLoad(
  () => import('./index'),
  module => module.ManagerPage,
);
